<!--
 * @创建文件时间: 2019-10-31 20:35:14
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-23 01:20:13
 * @联系Qq:1638245306
 * @文件介绍:
 -->
<template>
    <div>
        <el-popover placement="bottom-start" width="700" trigger="click" v-model="visible">
            <dynamic-form :ref='refName' :heights="heights" :formConfig="formConfig" v-model="value">
              <template slot="yjj_zy">
                <slot name="yjj_zy"></slot>
              </template>
            </dynamic-form>
            <el-button type="text" v-if="buttonShow" size="mini" @click="getAll" style="margin-left:20px">{{isAll}}<i :class="icons"></i></el-button>
            <div style="text-align: right; margin: 0" >
              <el-button size="mini" v-if="resetShow" @click="resetForm">清空</el-button>
              <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
            </div>
            <el-button slot="reference" icon="el-icon-search" style="width: 220px;text-align: left">{{title}}</el-button>
        </el-popover>
    </div>
</template>

<script>
  export default {
    name: 'popoverForm',
    data: function () {
        let height = '100px'
        if (this.formConfig && this.formConfig.list && this.formConfig.length <= 2){
            height = '50px'
        }

          return {
              refName: '',
              visible: false,
              heights: height,
              isAll: '展开全部',
              icons: 'el-icon-arrow-down',
              title: '点击搜索...'
          }
  },
      computed: {
        buttonShow () {
            return this.formConfig && this.formConfig.list && this.formConfig.list.length > 4
        }
      },
    props: {
      formConfig: {
        type: Object // ,
        // default: { list: [] }
      },
      value: {
        type: Object
      },
      //已弃用
      popoverWidth:{
        type:String,
        default:'900'
      },
      resetShow:{
        type:Boolean,
        default(){
          return true;
        }
      }
    },
    watch:{
    },
    methods:{
      // 提交
      onSubmit(){
        this.$emit('onSubmit', this.value)
        this.visible=false
      },
      getAll(){
        if(this.heights === 'auto'){
          this.heights='100px';
          this.isAll='展开全部';
          this.icons='el-icon-arrow-down';
        }else{
          this.heights='auto';
          this.isAll='收起全部';
          this.icons='el-icon-arrow-up';
        }
      },
      butClick(){

        this.formConfig.config.size="small";
        this.visible = !this.visible

      },
      // 重置
      resetForm(){
       let that = this
        that.$refs[that.refName].resetForm()
      }
    },
    create(){
       this.refName = 'popoverForm' + new Date().getTime();
    }
  }
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/aboutForm/popoverForm.vue"
}
</vue-filename-injector>
